import {
  EZEditorView,
  EZEditorViewProps,
  IVideoLocalizationWords,
} from "@axl/ez-editor-viewer-for-school";
import "@axl/ez-editor-viewer-for-school/dist/index.css";
import { Suspense, useEffect, useMemo } from "react";

import { useLoc, useSettings } from "@app/shared/lib/hooks";

type Props = Omit<EZEditorViewProps, "baseUrl"> & {
  noCopy?: boolean;
};

export const SchoolEZEditorView: React.FC<Props> = (props) => {
  const appSettings = useSettings();
  const loc = useLoc();

  const videoWords = useMemo<IVideoLocalizationWords>(
    () => ({
      copyTimecodeLink: loc.word("Video.timecode.copyLink", {
        default: "Copy the link to this moment",
      }),
      timecodeLinkCopied: loc.word("Video.timecode.linkCopied", {
        default: "Link copied",
      }),
    }),
    [loc],
  );

  /**
   * player post message
   */
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cb = (e: any) => {
      if (e.data.source !== "video") {
        return;
      }

      const axlData = window.AXLData;
      if (axlData) {
        e.source.postMessage(
          {
            source: "video",
            videoId: e.data.videoId,
            contactId: axlData.contactId,
            courseId: axlData.courseId,
            courseItemId: axlData.courseItemId,
            libraryId: axlData.libraryId,
            libraryItemId: axlData.libraryItemId,
          },
          "*",
        );
      }
    };

    window.addEventListener("message", cb);

    return () => window.removeEventListener("message", cb);
  }, []);

  return (
    <Suspense fallback={<div>Loading</div>}>
      <EZEditorView
        {...props}
        baseUrl={appSettings.api.baseUrl}
        videoWords={videoWords}
      />
    </Suspense>
  );
};
